// react_frontend/src/Components/Router/permissions.js
export const permissions = {
  1: { // Master Admin
    users: ["user", "employee", "salary"],
    category: ["add_category", "view_category"],
    items: true,
    products: true,
    inventory: true,
    billing: true,
    reports: true,
    customers: true,
    companySetting: true,
    hr: ["employee", "salary_increment", "attendance", "leave", "payroll", "assets", "expenses", "roster", "documents", "letters", "recruitment", "performance", "ai_chat", "requisition"], 
  },
  2: { // Admin
    users: ["user", "employee", "salary"],
    category: ["add_category", "view_category"],
    items: true,
    products: true,
    inventory: true,
    billing: true,
    reports: true,
    customers: true,
    companySetting: false,
    hr: ["employee", "salary_increment", "attendance", "leave", "payroll", "assets", "expenses", "roster", "documents", "letters", "recruitment", "performance", "ai_chat", "requisition"], 
  },
  3: { // Account
    users: ["salary"],
    category: [],
    items: false,
    products: false,
    inventory: true,
    billing: true,
    reports: true,
    customers: false,
    companySetting: false,
    hr: ["payroll", "salary_increment", "attendance", "expenses", "requisition"], 
  },
  4: { // Sales Manager / Employee
    users: [],
    category: [],
    items: false,
    products: false,
    inventory: false,
    billing: true,
    reports: false,
    customers: true,
    companySetting: false,
    hr: ["attendance", "salary_increment", "leave", "profile", "payslip", "ai_chat", "requisition", "documents", "letters", "performance" ], 
  }
};